import * as React from 'react';
import { ReactElement } from 'react';
import { toPairs, fromPairs } from 'lodash';
import {
    withTranslation as i18nTranslate,
    WithTranslation,
} from 'react-i18next';
import { TOptions } from 'i18next';
import { translationNameSpaces } from 'constants/app.constants';
import { ITranslationProps } from 'types/translation';

import './translate.styles.less';
import { addDefaultTextKeysOptions } from './translate-hoc.utils';
import { modifyTranslationKeysOptions } from './translate-hoc.utils';

// Custom Subtract type
type Subtract<T, K> = Omit<T, keyof K>;

// Custom Namespace type (you can adjust this based on your needs)
type CustomNamespace = string | string[];

export const translate = (
    namespaces: CustomNamespace = translationNameSpaces,
    options?: TOptions & { withRef?: boolean | undefined; keyPrefix?: undefined; }
) => <P extends WithTranslation>(Component: React.ComponentType<P>):
React.ComponentType<Subtract<P, ITranslationProps>> => {
    function translateHOC(props: P) {
        const { t, ...propsWithoutT } = props;
        return React.createElement<Pick<P, Exclude<keyof P, 't'>>>(
            Component, {
                ...propsWithoutT,
                /* We still might require original translation methods, when JSX element can't be used, like placeholders */
                originalTranslateKey: t,
                dangerouslyTranslateWithHTML(key: string | string[], translationOptions?: TOptions<object>): ReactElement {
                    const translationOptionsWithDefault = addDefaultTextKeysOptions(translationOptions);
                    const translatedOptions = fromPairs(
                        toPairs(translationOptionsWithDefault)
                            .map(modifyTranslationKeysOptions)
                            .map((pair) => [pair[0], t(pair[1])])
                    );
                    return (
                        <span
                            className="sitegen-translate-hoc"
                            dangerouslySetInnerHTML={{ __html: t(key, translatedOptions) }}
                        />
                    );
                }
            }
        );
    }
    translateHOC.displayName = Component.displayName;

    return i18nTranslate(namespaces, options)(translateHOC) as React.ComponentType<Subtract<P, ITranslationProps>>;
};
